import type { MailboxInfo } from "owa-client-types";
import getMailboxRequestOptions from "owa-service/lib/getMailboxRequestOptions";
import type SetFocusedInboxConfigurationRequest from "owa-service/lib/contract/SetFocusedInboxConfigurationRequest";
import type SetFocusedInboxConfigurationResponse from "owa-service/lib/contract/SetFocusedInboxConfigurationResponse";
import setFocusedInboxConfigurationOperation from "owa-service/lib/operation/setFocusedInboxConfigurationOperation";
import { getJsonRequestHeader } from "owa-service/lib/ServiceRequestUtils";

/**
 * Sets IsFocusedInboxCapable flag on server to indicate enable mailbox for focused inbox
 * @return the SetFocusedInboxConfigurationResponse
 */
export default function setIsFocusedInboxCapableService(mailboxInfo: MailboxInfo): Promise<SetFocusedInboxConfigurationResponse> {
    const request: SetFocusedInboxConfigurationRequest = {
        Header: getJsonRequestHeader(),
        IsFocusedInboxCapable: true,
    };
    
    return setFocusedInboxConfigurationOperation({
        request,
    }, getMailboxRequestOptions(mailboxInfo));
}
